import Vue from 'vue'
import * as Cookies from 'tiny-cookie'

Vue.prototype.$cookies = Cookies



// WEBPACK FOOTER //
// ./src/utils/cookies.js